import type { Dictionary } from '../types'

export const tr: Dictionary = {
  customers: {
    // ── List page ──────────────────────────────────────────────────────────
    pageTitle: 'Müşteri Yönetimi',
    pageDescription: 'Müşteri listesi ve hesap özeti',
    registeredCount: '{total} kayıtlı müşteri',
    statTotal: 'Toplam müşteri',
    statThisPage: 'Bu sayfa',
    statPageBalance: 'Sayfa bakiye toplamı',
    statPage: 'Sayfa',
    searchLabel: 'Arama',
    searchPlaceholder: 'Ad, e-posta, telefon veya kullanıcı adı',
    accountStatusLabel: 'Hesap durumu',
    perPageLabel: 'Sayfa başına',
    perPageOption: '{n} kayıt',
    refreshListAria: 'Listeyi yenile',
    listLoadError: 'Liste yüklenemedi. Lütfen tekrar deneyin.',
    colCustomer: 'Müşteri',
    colType: 'Tür',
    colPhone: 'Telefon',
    colBalance: 'Bakiye',
    colWithdrawable: 'Çekilebilir',
    colBlocked: 'Bloke',
    colCredit: 'Kredi',
    colRegistered: 'Üyelik',
    colGsm: 'GSM',
    colStatus: 'Durum',
    colActions: 'İşlem',
    emptyTitle: 'Müşteri bulunamadı',
    emptyFiltered: 'Filtreleri değiştirerek tekrar deneyin.',
    emptyNone: 'Henüz kayıtlı müşteri yok.',
    clearFilters: 'Filtreleri temizle',
    paginationInfo: 'Sayfa {current} / {last} · {total} müşteri',
    impersonateConfirm: '{email} olarak giriş yapmak istediğinize emin misiniz?',
    impersonateHint: 'Müşteri vitrini yeni sekmede açılır. Bu oturum sizin başlattığınız girişe aittir.',
    impersonateSuccess: 'Müşteri oturumu yeni sekmede açılıyor',
    impersonateFailed: 'Impersonate başarısız',
    impersonateBtn: 'Müşteri olarak giriş',
    actionMenu: 'İşlemler',
    actionSms: 'SMS Gönder',
    actionNotify: 'Bildirim Gönder',
    actionLogin: 'Oturum Aç',
    actionRestrict: 'Kısıtla',
    actionUnrestrict: 'Kısıtı kaldır',
    smsTitle: 'SMS gönder',
    smsPlaceholder: 'Kısa mesaj',
    smsSent: 'SMS gönderildi',
    notifyRowTitle: 'Bildirim gönder',
    notifyRowSent: 'Bildirim gönderildi',
    restricted: 'Müşteri kısıtlandı',
    unrestricted: 'Kısıt kaldırıldı',
    rowActionFailed: 'İşlem başarısız',
    viewCustomerAria: 'Müşteri detayı',
    impersonateAria: 'Müşteri olarak giriş yap',
    phoneVerified: 'Onaylı',
    phoneUnverified: 'Onaysız',
    emailVerified: 'E-posta onaylı',
    emailUnverified: 'E-posta onaysız',
    statusAll: 'Tüm durumlar',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    statusSuspended: 'Askıda',
    statusBanned: 'Yasaklı',

    // ── Detail page ────────────────────────────────────────────────────────
    detailBack: 'Müşteri Yönetimi',
    invalidId: 'Geçersiz müşteri kimliği.',
    notFound: 'Müşteri bulunamadı.',
    statSpend: 'Harcama',
    statOrders: 'Sipariş',
    statSales: 'Satış',
    accountBalance: 'Hesap Bakiyesi',
    editBalance: 'Bakiyeyi Düzenle',
    balanceNormal: 'Normal Bakiye',
    balanceWithdraw: 'Çekilebilir bakiye',
    balanceBlocked: 'Bloke bakiye',
    balanceCredit: 'Borç/Kredi bakiye',
    balanceBonus: 'Bonus bakiye',
    balanceAdjustMain: 'Ana bakiye',
    balanceAdjustWithdraw: 'Çekilebilir',
    balanceAdjustBlocked: 'Bloke',
    balanceAdjustCredit: 'Kredi',
    balanceAdjustBonus: 'Bonus',
    fieldId: 'Müşteri ID',
    fieldEmail: 'E-Posta',
    fieldGsm: 'GSM',
    fieldIdentity: 'Kimlik Numarası',
    fieldBirthdate: 'Doğum Tarihi',
    fieldRegisterDate: 'Kayıt Tarihi',
    fieldSmsVerify: 'SMS Onay',
    fieldEmailVerify: 'E-Posta Onay',
    fieldAccountStatus: 'Hesap Durumu',
    fieldCustomerType: 'Müşteri Türü',
    fieldUsername: 'Kullanıcı Adı',
    fieldName: 'Ad',
    fieldSurname: 'Soyad',
    foreignCustomer: 'Yabancı müşteri (11111111111)',
    verified: 'Onaylı',
    notVerified: 'Onaylı Değil',
    smsVerified: 'GSM onaylı',
    smsUnverified: 'GSM onaysız',
    editInfoAria: 'Bilgileri düzenle',
    saveAria: 'Kaydet',
    cancelEditAria: 'Düzenlemeyi iptal et',
    tabOrders: 'Sipariş Geçmişi',
    tabBanks: 'Banka Hesapları',
    tabPayments: 'Ödeme Bilgisi',
    tabTransactions: 'Hesap Hareketleri',
    tabAddresses: 'Adres Bilgileri',
    tabCart: 'Sepet',
    tabAccount: 'Hesap',
    tabPrices: 'Özel fiyat',
    tabApi: 'API Ayarları',
    tabLogs: 'Log Kayıtları',
    noBankAccounts: 'Kayıtlı banka hesabı yok',
    bankColBank: 'Banka',
    bankColHolder: 'Hesap sahibi',
    bankColIban: 'IBAN',
    bankColBranch: 'Şube',
    noBalanceTx: 'Bakiye hareketi yok',
    txColCode: 'Kod',
    txColType: 'Tür',
    txColAmount: 'Tutar',
    txColStatus: 'Durum',
    txColDate: 'Tarih',
    addAddress: 'Adres ekle',
    noAddresses: 'Kayıtlı adres yok',
    addressDefault: 'Varsayılan',
    addressDeleteConfirm: 'Bu adres silinsin mi?',
    apiNotActive: 'API ayarları henüz aktif değil',
    apiDescription: 'Müşteri bazlı ürün API / bayi entegrasyonu bu sürümde planlanıyor.',
    ordersTitle: 'Sipariş Geçmişi',
    ordersSearchPlaceholder: 'Sipariş ara...',
    ordersAllStatuses: 'Tüm Durumlar',
    ordersPending: 'Beklemede',
    ordersProcessing: 'İşlemde',
    ordersCompleted: 'Tamamlandı',
    ordersCancelled: 'İptal Edildi',
    ordersRefunded: 'İade Edildi',
    ordersEmpty: 'Sipariş bulunamadı',
    ordersColNo: 'Sipariş No',
    ordersColDate: 'Tarih',
    ordersColStatus: 'Durum',
    ordersColPayment: 'Ödeme',
    ordersColActions: 'İşlemler',
    ordersViewAria: 'Siparişi görüntüle',
    ordersTotal: 'Toplam {total} sipariş',
    statTotalOrders: 'Toplam Sipariş',
    statCompletedOrders: 'Tamamlanan Siparişler',
    statCancelledOrders: 'İptal Edilen Siparişler',
    statTotalSpend: 'Toplam Harcama',
    updateSuccess: 'Müşteri güncellendi',
    updateFailed: 'Kayıt başarısız',
    balanceSuccess: 'Bakiye güncellendi',
    balanceFailed: 'Bakiye güncellenemedi',
    addressUpdated: 'Adres güncellendi',
    addressAdded: 'Adres eklendi',
    addressSaveFailed: 'Adres kaydedilemedi',
    addressDeleted: 'Adres silindi',
    addressDeleteFailed: 'Adres silinemedi',
    balanceModalTitle: 'Bakiye Düzenle',
    balanceTypeLabel: 'Bakiye türü',
    balanceDirectionLabel: 'İşlem',
    balanceAdd: 'Ekle (+)',
    balanceSubtract: 'Çıkar (−)',
    balanceAmountLabel: 'Miktar',
    balanceDescLabel: 'Açıklama',
    addressEditTitle: 'Adres düzenle',
    addressNewTitle: 'Yeni adres',
    addrTitle: 'Başlık',
    addrType: 'Tür',
    addrShipping: 'Teslimat',
    addrBilling: 'Fatura',
    addrName: 'Ad',
    addrSurname: 'Soyad',
    addrAddress: 'Adres',
    addrCity: 'Şehir',
    addrDistrict: 'İlçe',
    addrPhone: 'Telefon',
    addrSelect: 'Seçin',
    addrDefaultLabel: 'Varsayılan adres',
    placeholderTabHint: 'Bu sekmede {title} bilgileri yer alacak.',

    // ── Notifications page ─────────────────────────────────────────────────
    notifTitle: 'Müşteri Bildirimleri',
    notifDescription: 'Sistem veya kampanya bildirimlerini yönetin',
    notifNewBtn: 'Yeni Bildirim',
    notifModalTitle: 'Yeni Müşteri Bildirimi Gönder',
    notifTitleField: 'Bildirim Başlığı',
    notifTitlePlaceholder: 'örn: Yeni Kampanya Başladı!',
    notifMessageField: 'Mesaj İçeriği',
    notifMessagePlaceholder: 'Müşterilere iletilecek mesaj...',
    notifTypeField: 'Bildirim Türü',
    notifTypeSystem: 'Sistem',
    notifTypeCampaign: 'Kampanya',
    notifTypeAccount: 'Hesap',
    notifTypeAlert: 'Uyarı',
    notifRecipients: 'Alıcılar ({count} seçili)',
    notifClearSelection: 'Seçimi Temizle',
    notifSearchPlaceholder: 'Müşteri ara...',
    notifNoCustomers: 'Müşteri bulunamadı.',
    notifValidationFields: 'Başlık ve mesaj alanları zorunludur.',
    notifValidationUsers: 'Lütfen en az bir müşteri seçin.',
    notifSending: 'Gönderiliyor…',
    notifSend: 'Gönder',
    notifSearchFilter: 'Başlık veya mesaj ara...',
    notifLoadError: 'Bildirimler yüklenemedi. Lütfen tekrar deneyin.',
    notifEmpty: 'Kayıtlı bildirim bulunamadı.',
    notifColRecipient: 'Alıcı',
    notifColType: 'Tür',
    notifColContent: 'Başlık & Mesaj',
    notifColStatus: 'Durum',
    notifColDate: 'Tarih',
    notifColActions: 'İşlem',
    notifUnknownUser: 'Bilinmiyor',
    notifStatusRead: 'Okundu',
    notifStatusPending: 'Bekliyor',
    notifDeleteConfirm: 'Bu bildirimi silmek istediğinize emin misiniz?',

    // ── Transactions page ──────────────────────────────────────────────────
    transTitle: 'Müşteri Hareketleri',
    transTotal: 'Toplam {total} kayıt',
    transTypesAll: 'Tüm türler',
    transTypeDeposit: 'Yükleme',
    transTypeWithdrawal: 'Çekim',
    transTypeTransfer: 'Transfer',
    transStatusAll: 'Tüm durumlar',
    transStatusPending: 'Bekliyor',
    transStatusCompleted: 'Tamamlandı',
    transStatusFailed: 'Başarısız',
    transCodeLabel: 'İşlem kodu',
    transColCode: 'İşlem Kodu',
    transColCustomer: 'Müşteri',
    transColType: 'Tür',
    transColMethod: 'Yöntem',
    transColAmount: 'Tutar',
    transColStatus: 'Durum',
    transColDate: 'Tarih',

    // ── Cart tab ───────────────────────────────────────────────────────────
    cartTitle: 'Aktif Sepet',
    cartDesc: "Müşterinin şu anki sepet içeriği — 30 sn'de bir otomatik yenilenir",
    cartDescription: "Müşterinin şu anki sepet içeriği — 30 sn'de bir otomatik yenilenir",
    cartItemCount: 'Sepette ürün',
    cartTotalQty: 'Toplam adet',
    cartEstimated: 'Tahmini tutar',
    cartEstimatedTotal: 'Tahmini tutar',
    cartUnavailable: 'Satışa kapalı',
    cartUnavailableCount: 'Satışa kapalı',
    cartEmpty: 'Boş',
    cartMixedCurrency: 'Sepette birden fazla para birimi var; tahmini tutar yaklaşık değerdir.',
    cartLoadError: 'Sepet bilgisi yüklenemedi.',
    cartEmptyTitle: 'Sepet boş',
    cartEmptyDesc: 'Bu müşterinin sepetinde ürün bulunmuyor.',
    cartColProduct: 'Ürün',
    cartColSource: 'Kaynak',
    cartColQty: 'Adet',
    cartColUnitPrice: 'Birim fiyat',
    cartColLineTotal: 'Satır tutarı',
    cartColStatus: 'Durum',
    cartColUpdated: 'Güncelleme',
    cartNoProductInfo: 'Ürün bilgisi yok',
    cartNoProductName: 'Ürün bilgisi yok',
    cartCoupon: 'Kupon',
    cartSourceStock: 'Stok',
    cartSourceMarketplace: 'Pazaryeri',
    cartAvailable: 'Satışta',
    cartUnavailableLabel: 'Uygun değil',

    // ── Payments tab ───────────────────────────────────────────────────────
    paymentsTitle: 'Ödeme Geçmişi',
    paymentsDesc: 'Müşterinin tüm ödeme işlemleri ve özet istatistikler',
    paymentsDescription: 'Müşterinin tüm ödeme işlemleri ve özet istatistikler',
    paymentsTotalTx: 'Toplam işlem',
    paymentsSuccessful: 'Başarılı',
    paymentsTotalSpend: 'Toplam harcama',
    paymentsPending: 'Bekleyen',
    paymentsFailed: 'Başarısız',
    paymentsRefund: 'İade',
    paymentsStatusAll: 'Tüm durumlar',
    paymentsStatusPending: 'Bekliyor',
    paymentsStatusCompleted: 'Tamamlandı',
    paymentsStatusFailed: 'Başarısız',
    paymentsStatusRefunded: 'İade edildi',
    paymentsStatusCancelled: 'İptal',
    paymentsRecordCount: '{total} kayıt',
    paymentsLoadError: 'Ödeme geçmişi yüklenemedi.',
    paymentsEmpty: 'Ödeme kaydı bulunamadı',
    paymentsColDate: 'Tarih',
    paymentsColAmount: 'Tutar',
    paymentsColMethod: 'Yöntem',
    paymentsColStatus: 'Durum',
    paymentsColOrder: 'Sipariş',
    paymentsColDesc: 'Açıklama',
    paymentsDetailAria: 'Detay',
    // Short alias keys used by CustomerPaymentsTab
    payStatusAll: 'Tüm durumlar',
    payStatusPending: 'Bekliyor',
    payStatusCompleted: 'Tamamlandı',
    payStatusFailed: 'Başarısız',
    payStatusRefunded: 'İade edildi',
    payStatusCancelled: 'İptal',
    payStatTotal: 'Toplam işlem',
    payStatCompleted: 'Başarılı',
    payStatTotalSpend: 'Toplam harcama',
    payStatPending: 'Bekleyen',
    payStatFailed: 'Başarısız',
    payStatRefunded: 'İade',
    payRecords: 'kayıt',
    payColDate: 'Tarih',
    payColAmount: 'Tutar',
    payColMethod: 'Yöntem',
    payColStatus: 'Durum',
    payColOrder: 'Sipariş',
    payColDesc: 'Açıklama',

    // ── Logs tab ───────────────────────────────────────────────────────────
    logsAllEvents: 'Tüm olaylar',
    logsLogin: 'Giriş',
    logsLogout: 'Çıkış',
    logsRegister: 'Kayıt',
    logsPasswordChange: 'Şifre değişimi',
    logsProfileUpdate: 'Profil güncelleme',
    logsCustomerUpdate: 'Admin müşteri güncelleme',
    logsBalanceAdjust: 'Bakiye düzenleme',
    logsImpersonate: 'Impersonate',
    logsAddressCreate: 'Adres ekleme',
    logsAddressUpdate: 'Adres güncelleme',
    logsAddressDelete: 'Adres silme',
    logsSearchPlaceholder: 'Log ara (mesaj, detay, IP...)',
    logsRefreshAria: 'Logları yenile',
    logsTotalCount: 'Toplam {total} kayıt',
    logsLoadError: 'Log kayıtları yüklenemedi.',
    logsEmptyTitle: 'Log kaydı bulunamadı',
    logsEmptyFiltered: 'Filtreleri değiştirerek tekrar deneyin.',
    logsEmptyNone: 'Bu müşteri için henüz log kaydı oluşmamış.',
    logsColPerformer: 'İşlem yapan',
    logsColIp: 'IP adresi',
    logsColEventType: 'Olay türü',
    logsColDesc: 'Açıklama',
    logsColDetail: 'Detay',
    logsColBrowser: 'Tarayıcı',
    logsColDate: 'Tarih',
    logsColMessage: 'Açıklama',
    // Short alias keys used by CustomerLogsTab
    logTypeAll: 'Tüm olaylar',
    logTypeLogin: 'Giriş',
    logTypeLogout: 'Çıkış',
    logTypeRegister: 'Kayıt',
    logTypePasswordChange: 'Şifre değişimi',
    logTypeProfileUpdate: 'Profil güncelleme',
    logTypeCustomerUpdate: 'Admin müşteri güncelleme',
    logTypeBalanceAdjust: 'Bakiye düzenleme',
    logTypeImpersonate: 'Impersonate',
    logTypeAddressCreate: 'Adres ekleme',
    logTypeAddressUpdate: 'Adres güncelleme',
    logTypeAddressDelete: 'Adres silme',
    logSearchPlaceholder: 'Log ara (mesaj, detay, IP...)',
    logRefresh: 'Logları yenile',
    logTotal: 'Toplam {total} kayıt',
    logLoadError: 'Log kayıtları yüklenemedi.',
    logEmptyTitle: 'Log kaydı bulunamadı',
    logEmptyFiltered: 'Filtreleri değiştirerek tekrar deneyin.',
    logEmptyNone: 'Bu müşteri için henüz log kaydı oluşmamış.',
    logColActor: 'İşlem yapan',
    logColIp: 'IP adresi',
    logColEventType: 'Olay türü',
    logColMessage: 'Açıklama',
    logColDetail: 'Detay',
    logColBrowser: 'Tarayıcı',
    logColDate: 'Tarih',
  },

  staff: {
    pageTitle: 'Personel Yönetimi',
    totalCount: 'Toplam {total} personel',
    addBtn: 'Personel ekle',
    searchLabel: 'Arama',
    roleLabel: 'Rol',
    allRoles: 'Tüm roller',
    colEmail: 'E-posta',
    colUsername: 'Kullanıcı adı',
    colRoles: 'Roller',
    colStatus: 'Durum',
    colRegistered: 'Kayıt',
    loadError: 'Liste yüklenemedi.',
    deleteConfirm: 'Bu personeli silmek istediğinize emin misiniz?',
    deleteSuccess: 'Personel silindi',
    deleteFailed: 'Silinemedi',
    modalEditTitle: 'Personel düzenle',
    modalNewTitle: 'Yeni personel',
    fieldEmail: 'E-posta',
    fieldUsername: 'Kullanıcı adı',
    fieldPassword: 'Şifre',
    fieldPasswordHint: 'Şifre (boş bırakılırsa değişmez)',
    fieldStatus: 'Durum',
    fieldRoles: 'Roller',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    statusSuspended: 'Askıda',
    effectivePermissions: 'Seçili rollerden gelen izinler ({count})',
    saveSuccess: 'Personel güncellendi',
    createSuccess: 'Personel eklendi',
    actionFailed: 'İşlem başarısız',
    // Aliases used by StaffPage/StaffFormModal
    editTitle: 'Personel düzenle',
    createTitle: 'Yeni personel',
    fieldPasswordOptional: 'Şifre (boş bırakılırsa değişmez)',
    effectivePermsLabel: 'Seçili rollerden gelen izinler ({count})',
    updateSuccess: 'Personel güncellendi',
    saveFailed: 'İşlem başarısız',
  },

  permissions: {
    pageTitle: 'İzin Yönetimi',
    pageDescription: 'Rol bazlı erişim kontrolü — Spatie Permission',
    newRoleBtn: 'Yeni Rol',
    statTotalRoles: 'Toplam Rol',
    statDefinedPerms: 'Tanımlı İzin',
    statSystemRoles: 'Sistem Rolü',
    loadError: 'Roller yüklenemedi. Lütfen tekrar deneyin.',
    emptyTitle: 'Henüz rol tanımlanmamış',
    createFirstBtn: 'İlk Rolü Oluştur',
    roleSystem: 'Sistem',
    roleUserCount: '{count} kullanıcı',
    rolePermCount: '{count} izin atanmış',
    noPerms: 'İzin yok',
    modalEditTitle: 'Rolü Düzenle',
    modalCreateTitle: 'Yeni Rol Oluştur',
    roleNameLabel: 'Rol Adı',
    roleNamePlaceholder: 'örn: editor, support',
    systemRoleHint: 'Sistem rolü adı değiştirilemez.',
    permissionsLabel: 'İzinler',
    selectedCount: '{count} Seçili',
    noDefinedPerms: 'Sistemde tanımlı izin bulunamadı.',
    validationName: 'Rol adı zorunludur.',
    savingBtn: 'Kaydediliyor…',
    updateBtn: 'Güncelle',
    createBtn: 'Oluştur',
    deleteTitle: 'Rolü Sil',
    deleteMessage: '"{name}" rolü silinecek.',
    deleteWarning: 'Bu role atanmış {count} kullanıcı varsa rolleri kaldırılacaktır. Bu işlem geri alınamaz.',
    deletingBtn: 'Siliniyor…',
    confirmDeleteBtn: 'Evet, Sil',
    errorOccurred: 'Bir hata oluştu.',
    otherGroup: 'Diğer',
    // Aliases used by PermissionsPage
    roleError: 'Bir hata oluştu.',
    roleNameRequired: 'Rol adı zorunludur.',
    editRoleTitle: 'Rolü Düzenle',
    createRoleTitle: 'Yeni Rol Oluştur',
    systemRoleNameLocked: 'Sistem rolü adı değiştirilemez.',
    noPermissionsDefined: 'Sistemde tanımlı izin bulunamadı.',
    deleteRoleTitle: 'Rolü Sil',
    deleteRoleWillDelete: 'rolü silinecek.',
    deleteRoleWarning: 'Bu role atanmış {count} kullanıcı varsa rolleri kaldırılacaktır. Bu işlem geri alınamaz.',
    pageDesc: 'Rol bazlı erişim kontrolü — Spatie Permission',
    noRoles: 'Henüz rol tanımlanmamış',
    createFirstRole: 'İlk Rolü Oluştur',
    systemRoleBadge: 'Sistem',
    userCount: '{count} kullanıcı',
    permCount: '{count} izin atanmış',
  },
}

export const en: Dictionary = {
  customers: {
    // ── List page ──────────────────────────────────────────────────────────
    pageTitle: 'Customer Management',
    pageDescription: 'Customer list and account overview',
    registeredCount: '{total} registered customers',
    statTotal: 'Total customers',
    statThisPage: 'This page',
    statPageBalance: 'Page balance total',
    statPage: 'Page',
    searchLabel: 'Search',
    searchPlaceholder: 'Name, email, phone or username',
    accountStatusLabel: 'Account status',
    perPageLabel: 'Per page',
    perPageOption: '{n} records',
    refreshListAria: 'Refresh list',
    listLoadError: 'Failed to load list. Please try again.',
    colCustomer: 'Customer',
    colType: 'Type',
    colPhone: 'Phone',
    colBalance: 'Balance',
    colWithdrawable: 'Withdrawable',
    colBlocked: 'Blocked',
    colCredit: 'Credit',
    colRegistered: 'Registered',
    colGsm: 'Phone',
    colStatus: 'Status',
    colActions: 'Actions',
    emptyTitle: 'No customers found',
    emptyFiltered: 'Try changing your filters.',
    emptyNone: 'No customers registered yet.',
    clearFilters: 'Clear filters',
    paginationInfo: 'Page {current} / {last} · {total} customers',
    impersonateConfirm: 'Are you sure you want to log in as {email}?',
    impersonateHint: 'The storefront opens in a new tab. This session belongs to the sign-in you start.',
    impersonateSuccess: 'Customer session opening in new tab',
    impersonateFailed: 'Impersonate failed',
    impersonateBtn: 'Log in as customer',
    actionMenu: 'Actions',
    actionSms: 'Send SMS',
    actionNotify: 'Send notification',
    actionLogin: 'Sign in',
    actionRestrict: 'Restrict',
    actionUnrestrict: 'Remove restriction',
    smsTitle: 'Send SMS',
    smsPlaceholder: 'Short message',
    smsSent: 'SMS sent',
    notifyRowTitle: 'Send notification',
    notifyRowSent: 'Notification sent',
    restricted: 'Customer restricted',
    unrestricted: 'Restriction removed',
    rowActionFailed: 'Action failed',
    viewCustomerAria: 'View customer',
    impersonateAria: 'Log in as customer',
    phoneVerified: 'Verified',
    phoneUnverified: 'Unverified',
    emailVerified: 'Email verified',
    emailUnverified: 'Email not verified',
    statusAll: 'All statuses',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusSuspended: 'Suspended',
    statusBanned: 'Banned',

    // ── Detail page ────────────────────────────────────────────────────────
    detailBack: 'Customer Management',
    invalidId: 'Invalid customer ID.',
    notFound: 'Customer not found.',
    statSpend: 'Spend',
    statOrders: 'Orders',
    statSales: 'Sales',
    accountBalance: 'Account Balance',
    editBalance: 'Edit Balance',
    balanceNormal: 'Main Balance',
    balanceWithdraw: 'Withdrawable balance',
    balanceBlocked: 'Blocked balance',
    balanceCredit: 'Credit balance',
    balanceBonus: 'Bonus balance',
    balanceAdjustMain: 'Main balance',
    balanceAdjustWithdraw: 'Withdrawable',
    balanceAdjustBlocked: 'Blocked',
    balanceAdjustCredit: 'Credit',
    balanceAdjustBonus: 'Bonus',
    fieldId: 'Customer ID',
    fieldEmail: 'Email',
    fieldGsm: 'Phone',
    fieldIdentity: 'Identity Number',
    fieldBirthdate: 'Date of Birth',
    fieldRegisterDate: 'Registration Date',
    fieldSmsVerify: 'SMS Verification',
    fieldEmailVerify: 'Email Verification',
    fieldAccountStatus: 'Account Status',
    fieldCustomerType: 'Customer Type',
    fieldUsername: 'Username',
    fieldName: 'First Name',
    fieldSurname: 'Last Name',
    foreignCustomer: 'Foreign customer (11111111111)',
    verified: 'Verified',
    notVerified: 'Not Verified',
    smsVerified: 'Phone verified',
    smsUnverified: 'Phone not verified',
    editInfoAria: 'Edit information',
    saveAria: 'Save',
    cancelEditAria: 'Cancel editing',
    tabOrders: 'Order History',
    tabBanks: 'Bank Accounts',
    tabPayments: 'Payment Info',
    tabTransactions: 'Account Movements',
    tabAddresses: 'Addresses',
    tabCart: 'Cart',
    tabAccount: 'Account',
    tabPrices: 'Custom prices',
    tabApi: 'API Settings',
    tabLogs: 'Activity Logs',
    noBankAccounts: 'No bank accounts on file',
    bankColBank: 'Bank',
    bankColHolder: 'Account holder',
    bankColIban: 'IBAN',
    bankColBranch: 'Branch',
    noBalanceTx: 'No balance transactions',
    txColCode: 'Code',
    txColType: 'Type',
    txColAmount: 'Amount',
    txColStatus: 'Status',
    txColDate: 'Date',
    addAddress: 'Add address',
    noAddresses: 'No addresses on file',
    addressDefault: 'Default',
    addressDeleteConfirm: 'Delete this address?',
    apiNotActive: 'API settings not active yet',
    apiDescription: 'Customer-specific product API / reseller integration is planned for a future release.',
    ordersTitle: 'Order History',
    ordersSearchPlaceholder: 'Search orders...',
    ordersAllStatuses: 'All Statuses',
    ordersPending: 'Pending',
    ordersProcessing: 'Processing',
    ordersCompleted: 'Completed',
    ordersCancelled: 'Cancelled',
    ordersRefunded: 'Refunded',
    ordersEmpty: 'No orders found',
    ordersColNo: 'Order No.',
    ordersColDate: 'Date',
    ordersColStatus: 'Status',
    ordersColPayment: 'Payment',
    ordersColActions: 'Actions',
    ordersViewAria: 'View order',
    ordersTotal: 'Total {total} orders',
    statTotalOrders: 'Total Orders',
    statCompletedOrders: 'Completed Orders',
    statCancelledOrders: 'Cancelled Orders',
    statTotalSpend: 'Total Spend',
    updateSuccess: 'Customer updated',
    updateFailed: 'Save failed',
    balanceSuccess: 'Balance updated',
    balanceFailed: 'Could not update balance',
    addressUpdated: 'Address updated',
    addressAdded: 'Address added',
    addressSaveFailed: 'Could not save address',
    addressDeleted: 'Address deleted',
    addressDeleteFailed: 'Could not delete address',
    balanceModalTitle: 'Edit Balance',
    balanceTypeLabel: 'Balance type',
    balanceDirectionLabel: 'Direction',
    balanceAdd: 'Add (+)',
    balanceSubtract: 'Subtract (−)',
    balanceAmountLabel: 'Amount',
    balanceDescLabel: 'Description',
    addressEditTitle: 'Edit address',
    addressNewTitle: 'New address',
    addrTitle: 'Title',
    addrType: 'Type',
    addrShipping: 'Shipping',
    addrBilling: 'Billing',
    addrName: 'First Name',
    addrSurname: 'Last Name',
    addrAddress: 'Address',
    addrCity: 'City',
    addrDistrict: 'District',
    addrPhone: 'Phone',
    addrSelect: 'Select',
    addrDefaultLabel: 'Default address',
    placeholderTabHint: 'This tab will show {title} information.',

    // ── Notifications page ─────────────────────────────────────────────────
    notifTitle: 'Customer Notifications',
    notifDescription: 'Manage system or campaign notifications',
    notifNewBtn: 'New Notification',
    notifModalTitle: 'Send New Customer Notification',
    notifTitleField: 'Notification Title',
    notifTitlePlaceholder: 'e.g. New Campaign Started!',
    notifMessageField: 'Message Content',
    notifMessagePlaceholder: 'Message to be sent to customers...',
    notifTypeField: 'Notification Type',
    notifTypeSystem: 'System',
    notifTypeCampaign: 'Campaign',
    notifTypeAccount: 'Account',
    notifTypeAlert: 'Alert',
    notifRecipients: 'Recipients ({count} selected)',
    notifClearSelection: 'Clear Selection',
    notifSearchPlaceholder: 'Search customers...',
    notifNoCustomers: 'No customers found.',
    notifValidationFields: 'Title and message are required.',
    notifValidationUsers: 'Please select at least one customer.',
    notifSending: 'Sending…',
    notifSend: 'Send',
    notifSearchFilter: 'Search by title or message...',
    notifLoadError: 'Failed to load notifications. Please try again.',
    notifEmpty: 'No notifications found.',
    notifColRecipient: 'Recipient',
    notifColType: 'Type',
    notifColContent: 'Title & Message',
    notifColStatus: 'Status',
    notifColDate: 'Date',
    notifColActions: 'Actions',
    notifUnknownUser: 'Unknown',
    notifStatusRead: 'Read',
    notifStatusPending: 'Pending',
    notifDeleteConfirm: 'Are you sure you want to delete this notification?',

    // ── Transactions page ──────────────────────────────────────────────────
    transTitle: 'Customer Transactions',
    transTotal: 'Total {total} records',
    transTypesAll: 'All types',
    transTypeDeposit: 'Deposit',
    transTypeWithdrawal: 'Withdrawal',
    transTypeTransfer: 'Transfer',
    transStatusAll: 'All statuses',
    transStatusPending: 'Pending',
    transStatusCompleted: 'Completed',
    transStatusFailed: 'Failed',
    transCodeLabel: 'Transaction code',
    transColCode: 'Transaction Code',
    transColCustomer: 'Customer',
    transColType: 'Type',
    transColMethod: 'Method',
    transColAmount: 'Amount',
    transColStatus: 'Status',
    transColDate: 'Date',

    // ── Cart tab ───────────────────────────────────────────────────────────
    cartTitle: 'Active Cart',
    cartDescription: "Customer's current cart — refreshes automatically every 30 seconds",
    cartItemCount: 'Items in cart',
    cartTotalQty: 'Total quantity',
    cartEstimated: 'Estimated total',
    cartUnavailableCount: 'Unavailable',
    cartEmpty: 'Empty',
    cartMixedCurrency: 'Cart contains multiple currencies; estimated total is approximate.',
    cartLoadError: 'Failed to load cart.',
    cartEmptyTitle: 'Cart is empty',
    cartEmptyDesc: "This customer's cart has no items.",
    cartColProduct: 'Product',
    cartColSource: 'Source',
    cartColQty: 'Qty',
    cartColUnitPrice: 'Unit price',
    cartColLineTotal: 'Line total',
    cartColStatus: 'Status',
    cartColUpdated: 'Updated',
    cartNoProductName: 'Product info unavailable',
    cartCoupon: 'Coupon: {code}',
    cartSourceStock: 'Stock #{id}',
    cartSourceMarketplace: 'Marketplace #{id}',
    cartAvailable: 'Available',
    cartUnavailableLabel: 'Unavailable',

    // ── Payments tab ───────────────────────────────────────────────────────
    paymentsTitle: 'Payment History',
    paymentsDescription: "All customer payment transactions and summary statistics",
    paymentsTotalTx: 'Total transactions',
    paymentsSuccessful: 'Successful',
    paymentsTotalSpend: 'Total spend',
    paymentsPending: 'Pending',
    paymentsFailed: 'Failed',
    paymentsRefund: 'Refund',
    paymentsStatusAll: 'All statuses',
    paymentsStatusPending: 'Pending',
    paymentsStatusCompleted: 'Completed',
    paymentsStatusFailed: 'Failed',
    paymentsStatusRefunded: 'Refunded',
    paymentsStatusCancelled: 'Cancelled',
    paymentsRecordCount: '{total} records',
    paymentsLoadError: 'Failed to load payment history.',
    paymentsEmpty: 'No payment records found',
    paymentsColDate: 'Date',
    paymentsColAmount: 'Amount',
    paymentsColMethod: 'Method',
    paymentsColStatus: 'Status',
    paymentsColOrder: 'Order',
    paymentsColDesc: 'Description',
    paymentsDetailAria: 'Details',
    payStatusAll: 'All statuses',
    payStatusPending: 'Pending',
    payStatusCompleted: 'Completed',
    payStatusFailed: 'Failed',
    payStatusRefunded: 'Refunded',
    payStatusCancelled: 'Cancelled',
    payStatTotal: 'Total transactions',
    payStatCompleted: 'Successful',
    payStatTotalSpend: 'Total spend',
    payStatPending: 'Pending',
    payStatFailed: 'Failed',
    payStatRefunded: 'Refund',
    payRecords: 'records',
    paymentsDesc: 'All customer payment transactions and summary statistics',
    payColDate: 'Date',
    payColAmount: 'Amount',
    payColMethod: 'Method',
    payColStatus: 'Status',
    payColOrder: 'Order',
    payColDesc: 'Description',

    // ── Logs tab ───────────────────────────────────────────────────────────
    logsAllEvents: 'All events',
    logsLogin: 'Login',
    logsLogout: 'Logout',
    logsRegister: 'Registration',
    logsPasswordChange: 'Password change',
    logsProfileUpdate: 'Profile update',
    logsCustomerUpdate: 'Admin customer update',
    logsBalanceAdjust: 'Balance adjustment',
    logsImpersonate: 'Impersonate',
    logsAddressCreate: 'Address created',
    logsAddressUpdate: 'Address updated',
    logsAddressDelete: 'Address deleted',
    logsSearchPlaceholder: 'Search logs (message, detail, IP...)',
    logsRefreshAria: 'Refresh logs',
    logsTotalCount: 'Total {total} records',
    logsLoadError: 'Failed to load activity logs.',
    logsEmptyTitle: 'No logs found',
    logsEmptyFiltered: 'Try changing your filters.',
    logsEmptyNone: 'No activity logs for this customer yet.',
    logsColPerformer: 'Performed by',
    logsColIp: 'IP address',
    logsColEventType: 'Event type',
    logsColDesc: 'Description',
    logsColDetail: 'Detail',
    logsColBrowser: 'Browser',
    logsColDate: 'Date',
    logsColMessage: 'Description',
    cartDesc: "Customer's current cart — refreshes automatically every 30 seconds",
    cartEstimatedTotal: 'Estimated total',
    cartUnavailable: 'Unavailable',
    cartNoProductInfo: 'Product info unavailable',
    cartCoupon: 'Coupon',
    cartSourceStock: 'Stock',
    cartSourceMarketplace: 'Marketplace',
    logTypeAll: 'All events',
    logTypeLogin: 'Login',
    logTypeLogout: 'Logout',
    logTypeRegister: 'Registration',
    logTypePasswordChange: 'Password change',
    logTypeProfileUpdate: 'Profile update',
    logTypeCustomerUpdate: 'Admin customer update',
    logTypeBalanceAdjust: 'Balance adjustment',
    logTypeImpersonate: 'Impersonate',
    logTypeAddressCreate: 'Address created',
    logTypeAddressUpdate: 'Address updated',
    logTypeAddressDelete: 'Address deleted',
    logSearchPlaceholder: 'Search logs (message, detail, IP...)',
    logRefresh: 'Refresh logs',
    logTotal: 'Total {total} records',
    logLoadError: 'Failed to load activity logs.',
    logEmptyTitle: 'No logs found',
    logEmptyFiltered: 'Try changing your filters.',
    logEmptyNone: 'No activity logs for this customer yet.',
    logColActor: 'Performed by',
    logColIp: 'IP address',
    logColEventType: 'Event type',
    logColMessage: 'Description',
    logColDetail: 'Detail',
    logColBrowser: 'Browser',
    logColDate: 'Date',
  },

  staff: {
    pageTitle: 'Staff Management',
    totalCount: 'Total {total} staff',
    addBtn: 'Add staff',
    searchLabel: 'Search',
    roleLabel: 'Role',
    allRoles: 'All roles',
    colEmail: 'Email',
    colUsername: 'Username',
    colRoles: 'Roles',
    colStatus: 'Status',
    colRegistered: 'Registered',
    loadError: 'Failed to load list.',
    deleteConfirm: 'Are you sure you want to delete this staff member?',
    deleteSuccess: 'Staff member deleted',
    deleteFailed: 'Could not delete',
    modalEditTitle: 'Edit staff member',
    modalNewTitle: 'New staff member',
    fieldEmail: 'Email',
    fieldUsername: 'Username',
    fieldPassword: 'Password',
    fieldPasswordHint: 'Password (leave blank to keep unchanged)',
    fieldStatus: 'Status',
    fieldRoles: 'Roles',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusSuspended: 'Suspended',
    effectivePermissions: 'Permissions from selected roles ({count})',
    saveSuccess: 'Staff member updated',
    createSuccess: 'Staff member added',
    actionFailed: 'Action failed',
    editTitle: 'Edit staff member',
    createTitle: 'New staff member',
    fieldPasswordOptional: 'Password (leave blank to keep unchanged)',
    effectivePermsLabel: 'Permissions from selected roles ({count})',
    updateSuccess: 'Staff member updated',
    saveFailed: 'Action failed',
  },

  permissions: {
    pageTitle: 'Permission Management',
    pageDescription: 'Role-based access control — Spatie Permission',
    newRoleBtn: 'New Role',
    statTotalRoles: 'Total Roles',
    statDefinedPerms: 'Defined Permissions',
    statSystemRoles: 'System Roles',
    loadError: 'Failed to load roles. Please try again.',
    emptyTitle: 'No roles defined yet',
    createFirstBtn: 'Create First Role',
    roleSystem: 'System',
    roleUserCount: '{count} users',
    rolePermCount: '{count} permissions assigned',
    noPerms: 'No permissions',
    modalEditTitle: 'Edit Role',
    modalCreateTitle: 'Create New Role',
    roleNameLabel: 'Role Name',
    roleNamePlaceholder: 'e.g. editor, support',
    systemRoleHint: 'System role name cannot be changed.',
    permissionsLabel: 'Permissions',
    selectedCount: '{count} Selected',
    noDefinedPerms: 'No permissions defined in the system.',
    validationName: 'Role name is required.',
    savingBtn: 'Saving…',
    updateBtn: 'Update',
    createBtn: 'Create',
    deleteTitle: 'Delete Role',
    deleteMessage: 'The role "{name}" will be deleted.',
    deleteWarning: 'Any users assigned to this role will have it removed. This action cannot be undone.',
    deletingBtn: 'Deleting…',
    confirmDeleteBtn: 'Yes, Delete',
    errorOccurred: 'An error occurred.',
    otherGroup: 'Other',
    roleError: 'An error occurred.',
    roleNameRequired: 'Role name is required.',
    editRoleTitle: 'Edit Role',
    createRoleTitle: 'Create New Role',
    systemRoleNameLocked: 'System role name cannot be changed.',
    noPermissionsDefined: 'No permissions defined in the system.',
    deleteRoleTitle: 'Delete Role',
    deleteRoleWillDelete: 'will be deleted.',
    deleteRoleWarning: 'Any users assigned to this role will have it removed. This action cannot be undone.',
    pageDesc: 'Role-based access control — Spatie Permission',
    noRoles: 'No roles defined yet',
    createFirstRole: 'Create First Role',
    systemRoleBadge: 'System',
    userCount: '{count} users',
    permCount: '{count} permissions assigned',
  },
}
